import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: ProducerCreateInput!
  ) {
    createOneProducer(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Produtor criado`, mutationTypes.CREATE)
)
